import { Upload } from "lucide-react"
import { useDropzone } from "react-dropzone"
import { classes } from "../../../../utils"
import { Button } from "../../../../components/ui/button"

interface FileUploadAreaProps {
  onUpload: (files: File[]) => void
  isUploading: boolean
}

export function FileUploadArea({ onUpload, isUploading }: FileUploadAreaProps) {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop: onUpload,
    multiple: false,
    noClick: true,
    noKeyboard: true,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'application/pdf': ['.pdf'],
    },
  })

  return (
    <div
      {...(getRootProps() as any)}
      class={classes(
        "border-2 border-dashed rounded-lg p-6 text-center transition-colors",
        isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 hover:border-gray-400"
      )}>
      <input {...getInputProps()} />
      <Upload className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <p class="text-lg font-medium text-gray-900 mb-2">
        {isDragActive ? "Drop file here" : "Drag & drop a promotional calendar file"}
      </p>
      <p class="text-sm text-gray-600">
        Supports PDF files best
      </p>
      <p class="text-xs text-gray-500 mt-1">
        For PDFs: Use custom page sizing to fit content on one page and remove unrelated content/pages for best results
      </p>
      <Button class="mt-4" onClick={open} disabled={isUploading}>
        <Upload className="h-4 w-4 mr-2" />
        {isUploading ? "Uploading..." : "Upload Files"}
      </Button>
      {isUploading && (
        <div class="mt-4">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
          <p class="text-sm text-gray-600 mt-2">Analyzing files...</p>
        </div>
      )}
    </div>
  )
}
